module.exports = __webpack_public_path__ + "static/media/bg_khai03.62e29404.png";